// src/hooks/useMediaQuery.js
//
// Un solo sitio donde se pregunta por el tamaño de la ventana. Antes cada
// componente que lo necesitaba montaba su propio `matchMedia` con su propio
// literal de breakpoint, así que "móvil" significaba 1024px en el Sidebar y
// otra cosa en la vista de al lado.
//
// `MOBILE_QUERY` es el negativo exacto del `md:` de Tailwind (768px): lo que
// esta constante llama móvil es lo mismo que las clases `md:` llaman móvil, y
// eso importa porque el shell reparte la responsabilidad entre las dos —el
// rail se oculta con CSS y el ancho que publica se calcula con JS.
import { useEffect, useState } from "react";

export const MOBILE_QUERY = "(max-width: 767px)";

function readMatch(query) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(query).matches;
}

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => readMatch(query));

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mq = window.matchMedia(query);
    const apply = (event) => setMatches(event.matches);
    // El primer render pudo pasar antes de que la ventana tuviera su tamaño
    // final (rotación, restauración de pestaña): re-leemos al montar.
    setMatches(mq.matches);
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, [query]);

  return matches;
}

export function useIsMobile() {
  return useMediaQuery(MOBILE_QUERY);
}

export default useMediaQuery;
